import { defineStore } from 'pinia'
import { setSpaceToDash } from '@ui/helpers/functions'
import { getDataLang } from '../helpers/api'

export interface Attractions {
  attraction_title: string
  category: string | null
  attraction_description: any
  attraction_image: string | null
  attraction_name: string
  attraction_preview?: string | null
}

export interface AttractionsState {
  list: Array<Attractions>
  loading: boolean
  categories: Array<string>
}

export const useAttractionsStore = defineStore('attractions', {
  state: (): AttractionsState => ({
    list: [],
    categories: [],
    loading: false,
  }),
  getters: {
    getList(): AttractionsState['list'] {
      return getDataLang(this.list, 0, 'attraction')
    },
    getCategories(): AttractionsState['list'] {
      interface CATEGORY {
        name: string
        code: string
      }
      let arr: CATEGORY[] = []
      const tmp = getDataLang(this.list, 0, 'attraction')
      if (tmp && tmp.length) {
        const uniqueCategories = [...new Set(tmp.map(item => item.category))]

        arr = [
          {
            name: 'All',
            code: '',
          },
          ...uniqueCategories.map(category => ({
            name: category,
            code: setSpaceToDash(category),
          })),
        ]
      }
      return arr
    },
  },
  actions: {
    async setList(data: Attractions[]) {
      this.list = data
    },
  },
})
